module.exports = __webpack_public_path__ + "static/liva-convert-detail7-0350856c2ad611e3df15bc89e649ca7f.png";